import { deleteApi, get, post } from "../GenericServices";

const ExpenseAccountType = {
  getExpenseAccountTypes: (queryString) => {
    return get(`expense-account-type${queryString !== "" ? `?${queryString}` : ""}`);
  },
  getExpenseAccountType: (id) => {
    return get(`expense-account-type/${id}`);
  },
  setExpenseAccountType: (data) => {
    return post(`expense-account-type`, data);
  },
  deleteExpenseAccountType: (id) => {
    return deleteApi(`expense-account-type/${id}`);
  },
  downloadExportFile: () => {
    return get(`expense-account-type/export`);
  },
};

export default ExpenseAccountType;
